angular
    .module('app')
    .component('winbackCampaigns', {
        templateUrl: '/templates/pages/winback-campaigns/winback-campaigns.html',
        controller: 'WinbackCampaignsController',
        controllerAs: 'vm',
    });